module.exports = __webpack_public_path__ + "static/pokemon-285f8d7b163e0d03ded06cce31823c10.jpg";